<template>
  <div class="footer-wrapper">
    <div class="footer">
      <div class="footer-inner">
        <div class="container">
          <div class="row">
            <div class="col-lg-4">
            </div>
            <div class="col-lg-4">
              <img src="/static/img/EurLogo.png" class="mid" alt="Home">
            </div>
            <div class="col-lg-4">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterSection',
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/utilities/FooterSection.vue